import store from '@/store'

export default function inResponsiveSizes(sizes) {
  return sizes.includes(store.getters.responsiveSize)
}
